import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation SubscribeToNewsletterMutation($input: SubscribeToNewsletterInput!) {
    subscribeToNewsletter(input: $input) {
      status
    }
  }
`;

function commit(environment, email, language, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        email,
        language,
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.subscribeToNewsletter.status);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
